const ModuleIdentifierConst = {
  FILE_MANAGEMENT: 'fileManagement',
  MAINTAINENCE: '"maintanance"',
  PAYOUT: 'payout',
  ACCOUNTING: 'accounting',
  DASHBOARD_MAPPING: 'dashboardMapping',
  SIMULATION: 'simulation',
  DATA_SYNC: 'dataSync',
  PERFORMANCE_DASHBOARD: 'allPerformanceDashboardView',
  PAYOUTREVIEWER_DASHBOARD: 'allPayoutReviewerDashboardView',
  TASKLIST_DASHBOARD: 'allTasklistDashboardView',
  TASK: 'TaskView',
  TEAMLEAD_DASHBOARD: 'allTeamLeadDashboardView',
  TARGET_SETTING: 'targetSettingManagement',
  HISTORICAL_VIEW: 'allTargetHistoricalReport',
  USER_PERFORMANCE_VIEW: 'allTargetUserPerformanceReport',
  TARGET_OVERRIDE: 'targetOverride', // old one targetSettingManagement because of this api url was geeting wrong so changed it to new one
  REPORTS: 'reports',
  NEED_TO_PAY: 'needToPay',
  UPLOAD_UTR: 'uploadUtr',
  PAYOUT_ADMIN: 'payoutAdmin',
  NO_DUES_CERTIFICATE: 'noDuesCertificate',
  HOLD_RELEASE_VIEW: 'holdReleaseView',
  CONTEST: 'contest',
  // DATA_CORRECTION: 'dataCorrection',
  DATA_CORRECTION: 'augment8ApplicationdataCorrection',
  TRANSACTION_SOURCES: 'augment8ApplicationtransactionSources',
  MASTER_SOURCES: 'augment8ApplicationmasterSources',
  RECALCULATION: 'Recalcultion',
  REPORT_CONFIG: 'reportConfiguration',
  // HOLD_VIEW: 'holdView',
  // RELEASE_VIEW: 'releaseView',
  // HOLD_RELEASE_TASK_CONFIG_VIEW: 'holdReleaseTaskConfgView'
};

export default ModuleIdentifierConst;
